import { observable, action } from 'mobx'
class AppStore {
    @observable wallet_amount = 0;
    @observable autoPlay = true;
    constructor() {

    }

    @action changeWalletAmount(amount) {
        this.wallet_amount = amount;
    }
    @action changeAutoPlay(autoplay) {
        this.autoPlay = autoplay;
    }
}

export default new AppStore()